import {ITEM_TRACK_HEIGHT, PAGE_TRACK_HEIGHT, RULER_HEIGHT, TRACK_GAP} from '@Components/poster-editor/components/timeline/timeline.types';

export const BOTTOM_BAR_MIN_HEIGHT = 135;
export const BOTTOM_BAR_MAX_HEIGHT = 600;
export const POSTER_EDITOR_WEB_BOTTOM_BAR_CONTAINER_ID = 'editor-web-bottom-seekbar';
export const POSTER_EDITOR_MOBILE_BOTTOM_BAR_CONTAINER_ID = 'editor-mobile-web-bottom-seekbar';

/** Playback-controls row height — mirrors $controls-bar-height in poster-editor-web-bottom-bar.module.scss. */
const CONTROLS_BAR_HEIGHT = 56;
/** Space under the last track — mirrors .tracksContainer's padding-bottom in timeline.module.scss. */
const TRACKS_BOTTOM_PADDING = 12;

/** Item rows shown in full above the background row when the panel opens. */
const FULLY_VISIBLE_ITEM_TRACKS = 2;

/**
 * Opening height of the timeline panel: the controls row, the sticky ruler, and — bottom-up, since
 * the open anchoring lands the track stack bottom-flush — the tracks padding, the audio row, the
 * full background row, FULLY_VISIBLE_ITEM_TRACKS item rows (each with its TRACK_GAP), and HALF of
 * the item row above those. The half-cropped top row is the visual cue that the track stack scrolls
 * vertically. Item rows are all ITEM_TRACK_HEIGHT tall, so the crop sits at half a row no matter
 * how many item rows the page has.
 */
export const BOTTOM_BAR_DEFAULT_HEIGHT =
  CONTROLS_BAR_HEIGHT +
  RULER_HEIGHT +
  ITEM_TRACK_HEIGHT / 2 +
  TRACK_GAP +
  (ITEM_TRACK_HEIGHT + TRACK_GAP) * FULLY_VISIBLE_ITEM_TRACKS +
  PAGE_TRACK_HEIGHT +
  TRACK_GAP +
  ITEM_TRACK_HEIGHT +
  TRACKS_BOTTOM_PADDING;
